export default __webpack_public_path__ + "icon_my_volvo.svg";